import React, {Component} from 'react';
import styled from 'styled-components';
import CheckoutButton from "./components/CheckoutButton";
import TermsAndConditions from "./components/TermsAndConditions";
import DateContainer from "./components/DateContainer";
import moment from "moment";
import Button from "./components/Button";
import {FormCodes} from "./constants/errorcodes";
import {BarLoader} from 'react-spinners';
import Style from "./constants/style";
import WelcomeHeader from "./components/WelcomeHeader";
import {Utils} from "./utils/Utils";
import {Analytics} from "./utils/Analytics";
import InputBox from "./components/InputBox";
import LargeTextBox from "./components/LargeTextBox";
import AddressContainer from "./components/AddressContainer";

const OrderPageContainer = styled.div`
`;

const CheckoutContainer = styled.div`
	padding-top: 50px;
	right: 0;
	width: ${props => props.fullscreen ? 100 : 30}vw;
	height: ${props => props.fullscreen ? '' : 'calc(100vh - 274px)'};
	display: flex;
	flex-direction: column;
	justify-content: center;
	background: ${props => props.fullscreen ? '#F8F8F8' : 'white'};
	border-top: 1px solid gray;
	border-bottom: ${props => props.fullscreen ? 'none' : '1px solid gray'};
	z-index: ${props => props.fullscreen ? 1000 : 2000};
	padding-bottom: ${props => props.fullscreen ? '50' : '0'}vh;
`;

const MarginAuto = styled.div`
	width: 160px;
	padding: ${props => props.padding || 0}px;
	margin: auto;
`;

const LoadingOverlay = styled.div`
	position: fixed;
	width: 100vw;
	height: 100vh;
	left: 0;
	top: 0;
	background: ${Style.transparentBlack};
	z-index: 5000;
	color: white;
	font-size: 48px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
`;

const BarLoadingContainer = styled.div`
	margin-top: 50px;
	width: 100%;
`;

const Header = styled.div`
	font-size: ${props => props.large ? 40 : 20}px;
	font-weight: 800;
	text-align: center;
`;

const TotalCost = styled.div`
	padding: 20px;
	font-size: 36px;
	font-weight: 800;
	color: darkgreen;
	text-align: center;
`;

const LookingForNameContainer = styled.div`
	padding-top: 100px;
`;

const ButtonContainer = styled.div`
	width: 90%;
	max-width: 500px;
	margin: auto;
	padding-top: 40px;
`;

const ErrorLabel = styled.div`
	padding-top: 30px;
	font-size: 20px;
	font-weight: ${props => props.red ? 800 : 400};
	color: ${props => props.red ? 'red' : 'black'};
	text-align: center;
`;

export default class App extends Component {
	constructor(props) {
		super(props);

		this.lastNameRef = React.createRef();

		const earliestDate = moment.max([moment().add(5, 'd'), moment('2023-12-18')]);

		this.state = {
			lookingForName: true,
			termsAccepted: false,
			comments: "",
			setupAddress: "",
			setupDate: earliestDate,
			teardownDate: moment('2024-01-22'),
			submitting: false,
			showingError: false,
			names: [
				// {name: "Chris Slee", price: 675},
				// {name: "Martyn Hughes", price: 550},
				// {name: "Ruth Huston", price: 315},
				// {name: "Lori Hall",price: 615},
				// {name: "Gina Krantz", price: 500},
				// {name: "Jennifer Ludowise", price: 620},
				// {name: "Patrice Croci", price: 345},
				// {name: "Jill Kirila", price: 700},
				// {name: "Lori Hall", price: 560},
				// {name: "Chelsea Humphries", price: 800},
				// {name: "Craig Clark", price: 995},
				// {name: "Craigg Gould", price: 1120},
				// {name: "Joanne Strasser", price: 525},
				// {name: "Nancy Ludowise", price: 150},
				// {name: "Alexandria Gormley", price: 350},
				// {name: "Annette Cullman", price: 450},
				// {name: "Stacy Thompson", price: 1750},
				// {name: "Kristy Copley", price: 900},
			  // {name: "Ed Copley", price: 900},
				// {name: "Kenneth Doss", price: 770},
				// {name: "Ken Doss", price: 770},
				// {name: "Tony Johnson", price: 625},
				// {name: "Shelli Montarsi", price: 575},
				// {name: "Naz Church", price: 1000},
				// {name: "Natosha Prolago", price: 525},
				// {name: "Heather Bradley", price: 830},
				// {name: "Patsy Strouse", price: 450},
				// {name: "Susy Lopez", price: 450},
				// {name: "John Mollenauer", price: 350},
				// {name: "Molly Riddle", price: 1250},
				// {name: "Anthony Wilson", price: 550},
				// {name: "Holly Meister", price: 575},
				// {name: "Samuel Mattern", price: 700},
				// {name: "Sanja Mattern", price: 700},
				// {name: "Michael Lackey", price: 825},
				// {name: "Jason McGee", price: 1300},
				// {name: "Nikita Goodman", price: 500},
				// {name: "Caroline Cooper", price: 500},
				// {name: "Mark Braunsdorf", price: 650},
				// {name: "Koble Grill", price: 725},
				// {name: "Ashleigh Strovolidis", price: 450},
				// {name: "Samuel Young", price: 1115},
				// {name: "David Morrison", price: 500},
				// {name: "Alison Scott", price: 1525},
				// {name: "Andrew Subotnik", price: 1255},
				// {name: "Peter Schanz", price: 1},
				// {name: "Neil DeWitt", price: 1075},
				// {name: "Andrea Benton", price: 675},
				// {name: "Sonali", price: 850},
				// {name: "Ted Nemeth", price: 750},
				// {name: "TESTING TESTING", price: 1},
			],
			selectedName: {name: "", price: 0},
			firstName: "",
			lastName: "",
		}
	}

	componentWillMount() {
		Analytics.logPageView();
	}

	render() {
		const subtotal = this.state.selectedName.price;
		// const tax = Math.ceil(subtotal * 0.07);
		const totalPrice = subtotal;

		const formValidityCheck = this.isFormValid();

		const issueResolver = (
			<MarginAuto padding={40}>
				<Button onClick={() => this.resolveIssueFor(formValidityCheck)}>
					Resolve
				</Button>
			</MarginAuto>
		);

		const lookingForName = (
			<LookingForNameContainer>
				<Header>
					Enter your name to look up last year's order:
				</Header>
				<InputBox
					value={this.state.firstName}
					placeholder="First Name"
					onChange={(event) => this.setState({firstName: event.target.value})}
					onKeyDown={this.keyDownFirstName}
				/>
				<InputBox
					ref={this.lastNameRef}
					value={this.state.lastName}
					placeholder="Last Name"
					onChange={(event) => this.setState({lastName: event.target.value})}
					onKeyDown={this.keyDownLastName}
				/>
				<ButtonContainer>
					<Button onClick={this.searchForLastYearOrder}>
						Search
					</Button>
					{this.state.showingError ? (
						<div>
							<ErrorLabel red>
								No Calendar availability.
								<br/>
								Please contact Peter for details.
							</ErrorLabel>
							<ErrorLabel>
								If you're still having issues,
								<br/>
								contact us directly at:
								<br/>
								<a href="mailto:peter@seasonalsetter.com">
									peter@seasonalsetter.com
								</a>
							</ErrorLabel>
						</div>
					) : null}
				</ButtonContainer>
			</LookingForNameContainer>
		);

		const loadingOverlay = this.state.submitting ? (
			<LoadingOverlay>
				<div>
					Submitting, please wait.
				</div>
				<BarLoadingContainer>
					<BarLoader
						css={{margin: 'auto'}}
						sizeUnit={"px"}
						height={7}
						width={250}
						color={"white"}
						loading={this.state.submitting}
					/>
				</BarLoadingContainer>
			</LoadingOverlay>
		) : null;

		return (
			<OrderPageContainer>
				{loadingOverlay}
				<WelcomeHeader/>
				{this.state.lookingForName ? lookingForName : (
					<CheckoutContainer fullscreen={true}>
						<Header>
							Ordering the same package from last year for:
						</Header>
						<Header large>
							{this.state.selectedName.name}
						</Header>
						<DateContainer setupDate={this.state.setupDate} teardownDate={this.state.teardownDate} onSetupDateChanged={(date) => this.setState({setupDate: date})} onTeardownDateChanged={(date) => this.setState({teardownDate: date})} />
						{/*<InlineContainer>*/}
						{/*	<Header left>*/}
						{/*		Subtotal:*/}
						{/*	</Header>*/}
						{/*	<InlineContentRight>*/}
						{/*		{Utils.formatAsCurrency(subtotal)}*/}
						{/*	</InlineContentRight>*/}
						{/*</InlineContainer>*/}
						{/*<InlineContainer>*/}
						{/*	<Header left>*/}
						{/*		Tax:*/}
						{/*	</Header>*/}
						{/*	<InlineContentRight>*/}
						{/*		{Utils.formatAsCurrency(tax)}*/}
						{/*	</InlineContentRight>*/}
						{/*</InlineContainer>*/}
						<br/><br/>
						<AddressContainer value={this.state.setupAddress} onChange={this.handleSetupAddressChange}/>
						<LargeTextBox title="Additional Comments? (Optional)" placeholder="Do you have any additional comments or things that we should know about? Be as specific as you'd like. We don't like word limits." value={this.state.comments} onChange={this.onCommentsChanged}/>
						<Header>
							Which brings your total this year to:
						</Header>
						<TotalCost>
							{Utils.formatAsCurrency(totalPrice)}
						</TotalCost>
						<Header>
							Please re-read the Terms and Conditions, since they are different this year.
						</Header>
						<TermsAndConditions accepted={this.state.termsAccepted} onCheckChanged={(status) => this.setState({termsAccepted: status})}/>
						<CheckoutButton invalidReason={formValidityCheck.reason} enabled={formValidityCheck.valid} options={this.state} deposit={totalPrice/5} fullAmount={totalPrice} setupDate={this.state.setupDate} submittingStatusChanged={status => this.setState({submitting: status})}/>
						{!formValidityCheck.valid ? issueResolver : null}
					</CheckoutContainer>
				)}
			</OrderPageContainer>
		);
	}

	searchForLastYearOrder = () => {
		const firstName = this.state.firstName.trim();
		const lastName = this.state.lastName.trim();
		const trimmedName = (firstName + " " + lastName).trim();
		const nameToFind = trimmedName.toLowerCase();
		const selectedName = this.state.names.filter(object => object.name.toLowerCase() === nameToFind).shift();
		if (selectedName !== undefined) {
			Analytics.logSearch(selectedName.name, true);
			this.setState({
				showingError: false,
				lookingForName: false,
				selectedName: selectedName
			});
		} else {
			Analytics.logSearch(trimmedName, false);
			this.setState({
				showingError: true
			});
		}
	};

	keyDownFirstName = (event) => {
		if (event.keyCode === 13) {
			this.lastNameRef.current.focus();
		}
	};

	keyDownLastName = (event) => {
		if (event.keyCode === 13) {
			this.searchForLastYearOrder();
		}
	};

	handleSetupAddressChange = setupAddress => {
		this.setState({ setupAddress });
	};

	onCommentsChanged = (newComments) => {
		this.setState({
			comments: newComments
		});
	};

	resolveIssueFor = ({code}) => {
		switch (code) {
			case FormCodes.TERMS:
				this.setState({termsAccepted: true});
				break;
			case FormCodes.HOUSE_SIZE:
				this.changeToSectionAtIndex(0);
				break;
			default:
				break;
		}
	};

	isFormValid = () => {
		if (!this.state.termsAccepted) {
			return {valid: false, reason: "You must accept the Terms and Conditions before checking out.", code: FormCodes.TERMS};
		}

		return {valid: true, reason: ""};
	};
}
